import React from "react";
import { XCircleIcon } from "lucide-react";
import { Link } from "react-router-dom";
import { Layout, SectionContent } from "@layouts/MainLayout";

const NotFoundPage: React.FC = () => {
  return (
    <Layout>
      <SectionContent>
        <div className="flex flex-col items-center justify-center h-screen bg-gray-100">
          <div className="bg-white p-8 rounded-lg shadow-lg text-center">
            <div className="flex justify-center mb-4">
              <XCircleIcon size={50} className="text-red-600 mb-4" />
            </div>

            <h1 className="text-3xl font-semibold text-gray-700">
              404 - Page Not Found
            </h1>

            <p className="mt-4 text-gray-600">
              <p className="text-gray-600 mb-4">
                The page you're looking for doesn't exist.
              </p>
              <Link to="/" className="text-blue-500 hover:text-blue-700">
                Go to Homepage
              </Link>
            </p>
          </div>
        </div>
      </SectionContent>
    </Layout>
  );
};

export default NotFoundPage;
